import { render, staticRenderFns } from "./swipers-pagination.vue?vue&type=template&id=a74072e6&scoped=true&"
import script from "./swipers-pagination.vue?vue&type=script&lang=js&"
export * from "./swipers-pagination.vue?vue&type=script&lang=js&"
import style0 from "./swipers-pagination.vue?vue&type=style&index=0&id=a74072e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74072e6",
  null
  
)

export default component.exports